// extracted by mini-css-extract-plugin
export default {"root":"Hyt0dzta","logo":"R9FWZvBo","main":"_6zTfOXjq"};